<template>
  <header class="layout-header">
    <div
      class="logo float-left cursor-pointer"
      @click="handleLogoClick"
    />
    <div class="search h-full float-right flex justify-center items-center">
      <el-input
        v-model="searchText"
        placeholder="search"
        class="mr-8"
      >
        <template #suffix>
          <el-icon>
            <ElIconSearch />
          </el-icon>
        </template>
      </el-input>

      <a
        href="https://bangtu.bangtu-ai.com/login"
        target="_blank"
      >
        <el-button
          type="primary"
        >
          免费试用
        </el-button>
      </a>
    </div>
    <div
      class="link h-full text-sm flex justify-center items-center overflow-hidden"
    >
      <HeaderMenus />
    </div>
  </header>
</template>

<script lang='ts' setup>
const { handleMenuChange } = useMenu()
// #region ========== 搜索框 =============
const searchText = ref('')
// #endregion ========== 搜索框 =============
function handleLogoClick() {
  const menu = {
    title: '首页',
    path: '/',
    pathName: 'Home',
  }
  handleMenuChange(menu)
}
</script>

<style scoped lang='scss'>
.layout-header {
  width: 100%;
  height: 90px;
  background: #fff;
  padding: 0 100px;
  border-bottom: 1px solid #D8E2EC;
}
.logo {
  width: 159px;
  height: 48px;
  margin-top: 16px;
  background-image: url('~/assets/imgs/home/logo-img.svg'), url('~/assets/imgs/home/logo-text-black.svg');
  background-repeat: no-repeat;
  background-position: left, right;
  background-origin: content-box;
  background-size: auto 100%, auto 100%;
}
.link {
  .el-button {
    --el-button-text-color: #000;
  }
  .el-button+.el-button {
    margin-left: 40px;
  }
}
.search {
  :deep(.el-input) {
    display: none;
    .el-input__wrapper {
      border-radius: 9999px;
    }
  }

  .el-button {
    border-radius: 9999px;
    padding: 13px 40px;
    height: 40px;
    font-size: 14px;
  }
}
</style>
